enum EVENTS {
  OPEN_INSIGHT_DRAWER = 'open-insight-drawer',
  SET_FAKE_LOADING_REPORT_DATA = 'set-fake-loading-report-data',
  DATA_AVAILABILITY = 'data-availability',
  OPEN_TOAST = 'open-toast',
  FILTER_CHANGED = 'filter-changed',
}

export { EVENTS }
